import React, { FC } from 'react'
import { LogoTransfix } from 'transfix-ui/components/LogoTransfix'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

interface IShareHeaderProps {
  title: string
}

const useStyles = makeStyles(theme => ({
  header: {
    [theme.breakpoints.down('md')]: {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)', // .box-shadow-med,
    },
    [theme.breakpoints.up('sm')]: {
      boxShadow: '0 1px 2px rgba(0,0,0,0.15)', // .box-shadow-low,
    },
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: brandColors.white,
    borderBottom: `1px solid ${brandColors.coolGray4}`,
    flexShrink: 0,
    height: theme.spacing(15),
    width: '100%',
    zIndex: 10, // .z-middle
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
}))

export const ShareHeader: FC<IShareHeaderProps> = ({ title }) => {
  const classes = useStyles()
  return (
    <header className={classes.header}>
      <Box className={classes.container}>
        <LogoTransfix width={194} color='black' />
        <Box pt={1}>
          <Typography variant='h3'>{title}</Typography>
        </Box>
      </Box>
    </header>
  )
}
